import {
  MODAL__POST_ARCHIVE,
  MODAL__POST_UNARCHIVE,
} from '../../../constants/routeModalParams';
import translate from '../../../i18n/translate';
import { ModalId } from '../../../models/modal';

/**
 * Returns some variable values (e.g. button label and modal id) which depend on the archived status of the message.
 *
 * @param isArchived Indicates whether the message is archived or not.
 * @returns          An object containing the button label and modal id based on the archived status.
 */
export const getButtonArchiveElements = (
  isArchived: boolean,
): { buttonLabel: string; modalId: ModalId } => {
  return {
    buttonLabel: isArchived
      ? translate('GENERAL__UNARCHIVE')
      : translate('GENERAL__ARCHIVE'),
    modalId: isArchived ? MODAL__POST_UNARCHIVE : MODAL__POST_ARCHIVE,
  };
};
